module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.3f2f4853.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/_global-styles/fonts/ProximaNova/ProximaNova-Regular.ttf
// module id = 805
// module chunks = 9